import type { DataTableAction, DataTableColumn } from '@/components/data-table/data-table.interface'
import { Badge } from '@/components/ui/badge'

import { MemberRoleBadge } from './member-role-badge.atom'
import type { OrganizationInvitation } from './members.interface'

const STATUS_BADGE_VARIANTS: Record<
  OrganizationInvitation['status'],
  'default' | 'secondary' | 'destructive'
> = {
  pending: 'secondary',
  accepted: 'default',
  revoked: 'destructive',
}

const STATUS_LABELS: Record<OrganizationInvitation['status'], string> = {
  pending: 'Pending',
  accepted: 'Accepted',
  revoked: 'Revoked',
}

export const INVITATION_COLUMN_LIST: DataTableColumn<OrganizationInvitation>[] = [
  {
    id: 'email',
    header: 'Email',
    cell: (row) => <span className="invitation-email font-medium">{row.emailAddress}</span>,
  },
  {
    id: 'memberRole',
    header: 'Role',
    cell: (row) => <MemberRoleBadge memberRole={row.memberRole} />,
    width: '120px',
  },
  {
    id: 'status',
    header: 'Status',
    cell: (row) => (
      <Badge variant={STATUS_BADGE_VARIANTS[row.status]} className="invitation-status-badge">
        {STATUS_LABELS[row.status]}
      </Badge>
    ),
    width: '100px',
  },
  {
    id: 'sent',
    header: 'Sent',
    cell: (row) => (
      <span className="text-muted-foreground">{row.createdAt.toLocaleDateString()}</span>
    ),
    width: '120px',
  },
]

export const createInvitationActionList = (
  canManageMembers: boolean,
  onRevokeInvitation: (invitationId: string) => void
): DataTableAction<OrganizationInvitation>[] => {
  if (!canManageMembers) return []

  return [
    {
      id: 'revoke',
      label: 'Revoke',
      onClick: (row) => onRevokeInvitation(row.id),
      variant: 'destructive',
      isDisabled: (row) => row.status !== 'pending',
    },
  ]
}
